import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTS } from 'src/app/core/config/constants';
import { Observable, of, Subject } from 'rxjs';
import { CommonService } from 'src/app/core/helper/common.service';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  customerViewInvoiceSubject: Subject<number> = new Subject();
  merchantiewInvoiceSubject: Subject<number> = new Subject();
  helpPopupSubject: Subject<number> = new Subject();
  

  constructor(private httpClient: HttpClient,
    private commonService: CommonService) { }

  /**
   * set customer view invoice data
   * @param invoiceData 
   */
  setCustomerViewInvoiceData(invoiceData: any) {
    this.customerViewInvoiceSubject.next(invoiceData);
  }

  /**
   * get customer view invoice data
   * @returns 
   */
  getCustomerViewInvoiceData(): Observable<any> {
    return this.customerViewInvoiceSubject;
  }


  /**
   * set merchant view invoice data
   * @param invoiceData 
   */
  setMerchantViewHeaderData(invoiceData: any) {
    this.merchantiewInvoiceSubject.next(invoiceData);
  }

  /**
   * get merchant view invoice data
   * @returns 
   */
  getMerchantViewHeaderData(): Observable<any> {
    return this.merchantiewInvoiceSubject;
  }


  /**
   * set help popup flag
   * @param flag 
   */
  setHelpPopupFlag(flag: any) {
    this.helpPopupSubject.next(flag);
  }

  /**
   * get help popup flag 
   * @returns 
   */
  getHelpPopupFlag():Observable<any>{
    return this.helpPopupSubject;
  }

  /**
   * get notification list
   * @returns 
   */
  getNotificationList(): Observable<any> {
    return this.httpClient.get(CONSTANTS.APP.BASE_API_URL_NOTIFICATION + CONSTANTS.API.ROUTE.NOTIFICATION.GET_NOTIFICATION+'?pageno=1&pagesize=100');
  }

  markAsReadNotification(dataDto): Observable<any> {
    return this.httpClient.put(CONSTANTS.APP.BASE_API_URL_NOTIFICATION + CONSTANTS.API.ROUTE.NOTIFICATION.GET_NOTIFICATION,dataDto);
  }
  

}
